import { Collapse, Switch } from 'antd';
import React, { ReactElement, type JSX } from 'react';
import styled from 'styled-components';

const { Panel } = Collapse;
type cookie = {
  title: string;
  description: ReactElement;
  accepted: boolean;
  editable?: boolean;
};

interface CookieListProps {
  cookies: { [key: string]: cookie };
  setCookies: React.Dispatch<React.SetStateAction<{ [key: string]: cookie }>>;
}

const StyledCookieContent = styled.div`
  td {
    padding: 6px 12px;
    vertical-align: top;
  }
`;

const CookieList = ({ cookies, setCookies }: CookieListProps): JSX.Element => {
  const CookieToggle = (cookie: string): JSX.Element => {
    return (
      <Switch
        defaultChecked={cookies[cookie].accepted}
        disabled={!cookies[cookie].editable}
        onChange={(checked, e) => {
          e.stopPropagation();

          const updatedCookies = { ...cookies };
          updatedCookies[cookie].accepted = checked;

          setCookies({ ...updatedCookies });
        }}
      />
    );
  };
  return (
    <Collapse accordion>
      {Object.keys(cookies).map((cookie) => {
        return (
          <Panel key={cookie} header={`${cookies[cookie]?.title}`} extra={CookieToggle(cookie)}>
            <StyledCookieContent>{cookies[cookie]?.description}</StyledCookieContent>
          </Panel>
        );
      })}
    </Collapse>
  );
};

export default CookieList;
